import { WidgetTexts } from 'widget/consts/texts';

export type DownloadFileArgs = {
  url: string;
  filename: string;
  onError?: (error: Error) => void;
};

export const downloadFile = async ({
  url,
  filename,
  onError
}: DownloadFileArgs): Promise<void> => {
  if (!url || !filename) {
    throw new Error(WidgetTexts.shared.downloadFile.error.unknown);
  }

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(WidgetTexts.shared.downloadFile.error.unknown);
    }

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    if (!onError) {
      return;
    }

    onError(
      error instanceof Error
        ? error
        : new Error(WidgetTexts.shared.downloadFile.error.unknown)
    );
  }
};
